import { BREAKPOINTS } from "constants/app";

const isMobile = () => window.innerWidth < 768;
const isDesktopBelow = () => window.innerWidth < 1200;
const isTablet = () => window.innerWidth < 1024 && window.innerWidth >= 768;
const isDesktop = () => window.innerWidth >= 1200;

const getCurrentBreakpoint = () => {
	let breakpoint;
	const { innerWidth: width } = window;
	if(width > 1200) breakpoint = BREAKPOINTS.desktopWeb;
	else if (width >= 1024 && width <= 1200) breakpoint = BREAKPOINTS.desktopWebBelow;
	else if (width >= 768 && width < 1024) breakpoint = BREAKPOINTS.tabletWeb;
	else breakpoint = BREAKPOINTS.mobileWeb;
	return breakpoint;
};

export { isMobile, isDesktopBelow, isTablet, isDesktop, getCurrentBreakpoint };
